/**
 * 思维导图
 */
import React, { useEffect, useMemo, useState } from "react"
import { saveSvgAsPng } from '@/utils/svg';
import { store } from "./store";
import { observer } from 'mobx-react-lite';
import { Transformer } from 'markmap-lib';
import { HelperCore } from '@/common/helper';
import EE from '@/common/event';
import {
  getMindmapXmind
} from '@/services/chat';

import Markmap from '@/components/markmap';
import { Tooltip } from 'antd' 
import { SVGPureIcon } from '@ui/svg-icon';
import { Modal } from 'antd';
import MMDownload from '@/components/mm-download'

import "./index.scss"
import Watermark from '@/components/watermark';

const MindmapModal = observer(() => {
  const svgRefModal = React.createRef();
  const svgRefCopy = React.createRef();
  const svgRefCopyWrap = React.createRef();

  const [modalShow, setModalShow] = useState(false)
  const [modal100, setModal100] = useState(false)
  const [page, setPage] = useState([])
  const [mindmap, setMindmap] = useState("")

  let rootData = null

  const watermark = useMemo(() => {
    return null;
  }, []);

  const prehandleMindmap = (mindmap) => {
    let ret = ""

    if(mindmap) {
      // mindmap = mindmap.replace(/\\n/g, "\n")
      mindmap = mindmap.replace(/\~/g, " ~ ")
      mindmap = mindmap.replace(/([\d]+)\*([\d]+)/g, "$1 * $2")
      mindmap = mindmap.replace(/(\n)[\s]+(#)/g, "$1$2")
      // mindmap = mindmap.replace(/(\n)[\s]+(\-)/g, "$1$2")
      mindmap = mindmap.replace(/\$.+\$/g, "")

      ret = mindmap
    }

    return ret
  }

  const transformMindmap = () => {
    const transformer = new Transformer();
    rootData = transformer.transform(mindmap)?.root || {}
  }

  transformMindmap()

  const convertToXmind = () => {
    let ret = []
    let id = 0

    const convertNode = (node, parentId="") => {
      if(node) {
        let retItem = {}
        retItem.node_id = ++id + ""
        retItem.topic_content = node?.content?.replace(/<[^>]*>/g, "").replace(/&quot;/g, "\"")
        if(parentId) {
          retItem.parent_id = parentId + ""
        }
        ret.push(retItem)
        node?.children?.forEach(child => {
          convertNode(child, retItem.node_id)
        })
      }
    }

    rootData && convertNode(rootData)

    return ret
  }

  const downloadSvg = (action) => {
    if(action == "xmind") {
      getMindmapXmind({
        x_mind: JSON.stringify(convertToXmind())
      }).then(({ data }) => {
        if(data?.url) {
          HelperCore.saveFileCrossOrigin(data?.url?.replace("http:", "https:"), `${page?.length ? page[0]?.title : ""}.xmind`)
        }
      })
    }

    if(action == "png") {
      saveSvgAsPng(svgRefCopyWrap.current, page?.length ? page[0]?.title : "")
    }
  }

  const rescale = (number=1) => {
    store.getData()?.rescale(number)
  }

  const fit = () => {
    store.getData()?.fit()
  }

  const showModal = () => {
    setModalShow(true)
    setModal100(false)
  }

  const hideModal = () => {
    setModalShow(false)
    setModal100(false)
  }

  const changeModalSize = () => {
    setModal100(!modal100)
    setTimeout(() => {
      fit()
    }, 20)
  }

  useEffect(() => {
    EE.on("mindmap:modal:show", (message) => {
      setPage(message.page || [])
      setMindmap(prehandleMindmap(message.mindmap || ""))
      showModal()
    })
  }, [])

  return (
    <div>
      {
        mindmap ? 
        <div>
          <div ref={svgRefCopyWrap} style={{
            position: "fixed",
            top: "0px",
            left: "30000px",
            padding: "32px",
            paddingBottom: "0px",
            width: "100vw",
            height: "100vh",
            boxSizing: "border-box"
          }}>
            <Markmap 
              rootData={rootData} 
              style={{
                width: "100%",
                height: "calc(100% - 114px)"
              }} 
              markviewConf={{ autoFit: true, zoom: true, pan: true, maxWidth: 400, spacingVertical: 20 }}
              ref={svgRefCopy}/>
            <div style={{
              width: "100%",
              height: "114px",
              position: "relative"
            }}>
              <img 
                style={{width: "205px", height: "74px", position: "absolute", right: "0px", top: "8px"}}
                src="https://p3.ssl.qhimg.com/t110b9a9301359874f5abf9b878.png"
                alt="mindmap-logo" />
            </div>
          </div>
          <Modal open={modalShow} 
            className={`mindmap-full ${modal100 ? "mindmap-full-100" : ""}`}
            destroyOnClose={true} 
            footer={null} 
            closeIcon={<>
              <SVGPureIcon 
                name="mindmap_full_close_v2" 
                size={32}
                className="text-black mindmap_full_close_v2"/>
              <SVGPureIcon 
                name="mindmap_full_close_v2_hover" 
                size={32}
                className="text-black mindmap_full_close_v2_hover"/>
            </>
            }
            onCancel={hideModal}
            centered={true}>
            <div className="w-full h-full relative bg-card-body">
              <Watermark content={watermark}>
              <Markmap 
                rootData={rootData} 
                className="w-full h-full mindmap-full-svg" 
                ref={svgRefModal} 
                markviewConf={{ autoFit: false, zoom: true, pan: true, maxWidth: 400, fitRatio: 0.9, spacingVertical: 28, style: () => ".mindmap-full-svg-extend-wrap{float:left;margin-left: calc(100% + 15px);margin-top: -8px;width: 45px;height: 16px;}" }}
                onRender={(markmapInstance) => {
                  store.setData(markmapInstance)
                  markmapInstance?.fit()
                }}/>
              </Watermark>
              <div className="flex items-center cursor-pointer group justify-end absolute bottom-[24px] right-[24px]">
                <Tooltip title={"放大"} destroyTooltipOnHide>
                  <button onClick={() => { rescale(1.25) }} className="ml-[14px] rounded-7px p-[2px] hover:bg-[rgba(0,0,0,0.6)] bg-[rgba(0,0,0,0.4)]">
                      <SVGPureIcon 
                        name="mindmap_amplify_v2" 
                        size={24}
                        color={"#ffffff"}
                      />
                  </button>
                </Tooltip>
                <Tooltip title={"缩小"} destroyTooltipOnHide>
                  <button onClick={() => { rescale(0.8) }} className="ml-[14px] rounded-7px p-[2px] hover:bg-[rgba(0,0,0,0.6)] bg-[rgba(0,0,0,0.4)]">
                      <SVGPureIcon 
                        name="mindmap_reduce_v2" 
                        size={24}
                        color={"#ffffff"}
                      />
                  </button>
                </Tooltip>
                <Tooltip title={"适配"} destroyTooltipOnHide>
                  <button onClick={() => { fit() }} className="ml-[14px] rounded-7px p-[2px] hover:bg-[rgba(0,0,0,0.6)] bg-[rgba(0,0,0,0.4)]">
                      <SVGPureIcon 
                        name="mindmap_fit_v2" 
                        size={24}
                        color={"#ffffff"}
                      />
                  </button>
                </Tooltip>
                <Tooltip title={modal100 ? "退出全屏" : "全屏"} 
                  trigger={["click", "hover"]}
                  getPopupContainer={node => node}
                  destroyTooltipOnHide>
                  <button onClick={changeModalSize} className="ml-[14px] rounded-7px p-[2px] hover:bg-[rgba(0,0,0,0.6)] bg-[rgba(0,0,0,0.4)]">
                      {
                        modal100 
                        ? <SVGPureIcon 
                            name="mindmap_exit_100" 
                            size={24}
                            color={"#ffffff"}
                          />
                        : <SVGPureIcon 
                            name="mindmap_to_100" 
                            size={24}
                            color={"#ffffff"}
                          />
                      }
                  </button>
                </Tooltip>
                <MMDownload className="ml-[14px]" download={downloadSvg}/>
              </div>
            </div>
          </Modal>
        </div>
        : null
      }
    </div>
  )
});
export default MindmapModal;
